import * as React from 'react';

const BentoPlaceholderContext = React.createContext(null);

export const WithRenderer = BentoPlaceholderContext.Provider;

export interface BentoPlaceholderProps {
  region: string;
}

export const BentoPlaceholder: React.FC<BentoPlaceholderProps> = ({ region }) => (
  <BentoPlaceholderContext.Consumer>{renderer => renderer(region)}</BentoPlaceholderContext.Consumer>
);
